<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aooFjL/tc-custom/9780547541273.jpg?1734282772566" alt="This image is the cover for the book Last Talk with Lola Faye"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Talk with Lola Faye
      </h1>
      <p class="bookDescription body article font2">
        <b>A “marvelously tense” novel of psychological suspense centered on a long-ago crime of passion, from an Edgar Award–winning author (<i>Publishers Weekly</i>, starred review).</b><br/><br/> With dreams of academic greatness, Lucas Paige rose from humble and sordid beginnings to attend Harvard. But his achievements since then have been meager. In St. Louis to give yet another sparsely attended reading, he discovers a face from the past he’s tried to forget: Lola Faye Gilroy, the “other woman” he long blamed for his father’s murder.<br/>  <br/> Reluctantly, Luke joins Lola Faye for a drink. As one drink turns into several, these two battered souls relive, from their different perspectives, the most searing experience of their lives. They are transported back to the tiny southern town of Glenville, Alabama, where a violent crime of passion is turned in the light once more. As it turns out, there is much Luke doesn’t know. And what he doesn’t know can hurt him.<br/>  <br/> Trapped in an increasingly intense exchange, Luke struggles to gain control and determine what Lola Faye is truly after—before it is too late.<br/>  <br/> This “darkly powerful” (<i>Kirkus Reviews</i>) literary thriller, rich with Southern atmosphere, is “a knockout” (<i>People</i>).<br/>  <br/> “Cook continues his work as one of the best fiction writers in America.” —<i>The Plain Dealer</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas H. Cook
      </h2>
      
      <p class="authorDescription body article"> THOMAS H. COOK was born in Fort Payne, Alabama. He has been nominated for Edgar Awards seven times in five different categories. He received the Best Novel Edgar, the Barry for Best Novel, and has been nominated for numerous other awards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cf1d74d